var map = {
	"./autografika.jpg": "ea40",
	"./cerade.jpg": "dbb8",
	"./forekspleksi.jpg": "4948",
	"./promo.jpg": "8a82",
	"./prozorska-grafika.jpg": "a228",
	"./pvc-naljepnice.jpg": "52ee",
	"./svijetlece-reklame.jpg": "d6dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e1d";